// extracted by mini-css-extract-plugin
module.exports = {"inputHolder":"boolean-input_inputHolder__2joVs"};